module.exports = __webpack_public_path__ + "static/fonts/iconfont.8b608b9.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/font/iconfont.woff2?t=1780902215335
// module id = P+Ba
// module chunks = 143